export default [
  {
    path: '/coupons',
    name: 'coupons',
    component: () => import('./pages/Coupons.vue'),
    meta: {
      authenticatedOnly: true
    }
  }
]
